// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#arg-disabled-button.theme--light.v-btn.v-btn--disabled .v-btn__content .v-icon{\n    color: #4caf4fc0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
